let Vue = require('vue');
let selectActionTemplate = require('templates/ui-select-property-highlight.html')
Vue.component('select-property-highlight', {
    template: selectActionTemplate,
    twoWay: true,
    props: {
        options:{
            type: Array
        },
        onSelect: {
            type: Function
        },
        portalId:{
            type: Number,
            default: null
        },
        current: {
            default: ''
        },
        // id do portal
        portal: {
            type: Number
        },
        // id do property
        property: {
            type: Number
        }
    },
    data() {
        return {
        }
    },ready() {
        if(this.current){
            for (let obj in this.options){

                if(this.options[obj].id == this.current){
                    this.current = this.options[obj].name;
                }
            }
        }
        if(!this.current){
             this.current = this.options[0].name;
        }
    },
    methods: {
        select(result) {
            this.current = result.name;
            if(this.onSelect){
                this.onSelect(this.property, this.portal, {highlight: result.id});
            }
        }
    }
});


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/select-property-highlight.js